import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-logo">
              <img src="/logo.png" alt="Nihansh Foundation Logo" className="footer-logo-img" />
              <span className="footer-logo-text">निहांश फाउंडेशन</span>
            </div>
            <p className="footer-text">
              पटना, बिहार में सर्वोच्च नशा मुक्ति केंद्र - आपके स्वस्थ जीवन की यात्रा में आपका साथी
            </p>
            <p className="footer-description">
              <b>निहांश फाउंडेशन</b> एक विश्वसनीय और प्रमाणित <b>नशा मुक्ति केंद्र</b> है जो व्यक्तियों को नशे की लत से मुक्त करने और उन्हें एक स्वस्थ, खुशहाल जीवन जीने में मदद करता है। हमारे अनुभवी डॉक्टरों, परामर्शदाताओं और सहायक स्टाफ की टीम 24/7 आपकी सेवा के लिए तैयार है।
            </p>
          </div>
          <div className="footer-links">
            <h3 className="footer-links-title">त्वरित लिंक</h3>
            <ul className="footer-menu">
              <li><Link to="/">होम</Link></li>
              <li><Link to="/about">हमारे बारे में</Link></li>
              <li><Link to="/services">सेवाएं</Link></li>
              <li><Link to="/nasha-mukti-kendra-in-patna">Nasha Mukti Kendra in Patna</Link></li>
              <li><Link to="/best-nasha-mukti-kendra-in-patna">Best Nasha Mukti Kendra in Patna</Link></li>
              <li><Link to="/contact">संपर्क करें</Link></li>
            </ul>
          </div>
          <div className="footer-contact">
            <h3 className="footer-links-title">संपर्क</h3>
            <p className="footer-contact-info">
              <strong>📍 पता:</strong><br />
              Krishna Niketan, School Road,<br />
              Near Bajrangi Chowk, Jakariyapur,<br />
              Zero Mile, Pahari, Patna, Bihar 800030, India
            </p>
            <p className="footer-contact-info">
              <strong>📞 फोन:</strong><br />
              <a href="tel:+916202410010">+91 6202410010</a>
            </p>
            <p className="footer-contact-info">
              <strong>✉️ ईमेल:</strong><br />
              <a href="mailto:nihanshfoundation@gmail.com">nihanshfoundation@gmail.com</a>
            </p>
          </div>
          <div className="footer-location">
            <h3 className="footer-links-title">हमारा स्थान</h3>
            <div className="footer-map-wrapper-small">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3599.2435780281214!2d85.17808042346827!3d25.5813031!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f2a70485e4f85f%3A0xdb75cf2222f15636!2sNihansh%20Foundation!5e0!3m2!1sen!2sin!4v1703691234567&z=19"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: '12px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map of Nihansh Foundation"
              ></iframe>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} निहांश फाउंडेशन. सभी अधिकार सुरक्षित।
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

